import gql from 'graphql-tag';

/**
 * Query to fetch home page content including featured posts and paginated published posts.
 *
 * @param limit - Number of published posts to fetch (required)
 * @param skip - Number of published posts to skip for pagination (required)
 * @returns Featured posts (positions _0 through _4) and paginated published posts with images, authors, and categories
 * @usedIn Home page layout and getStaticProps
 */
export const HOME_POSTS = gql`
  query homePosts($limit: Int!, $skip: Int!) {
    homepageSettings {
      showHero
      showFeatured
    }
    featuredPosts {
      _0 {
        title
        slug
        image {
          sourceUrl
          sourceSet
        }
        type
        publishedAt
        modifiedAt
        authors {
          displayName
          preferredUsername
        }
        categories {
          name
          slug
        }
      }
      _1 {
        title
        slug
        image {
          sourceUrl
          sourceSet
        }
        type
        publishedAt
        modifiedAt
        authors {
          displayName
          preferredUsername
        }
        categories {
          name
          slug
        }
      }
      _2 {
        title
        slug
        image {
          sourceUrl
          sourceSet
        }
        type
        publishedAt
        modifiedAt
        authors {
          displayName
          preferredUsername
        }
        categories {
          name
          slug
        }
      }
      _3 {
        title
        slug
        image {
          sourceUrl
          sourceSet
        }
        type
        publishedAt
        modifiedAt
        authors {
          displayName
          preferredUsername
        }
        categories {
          name
          slug
        }
      }
      _4 {
        title
        slug
        image {
          sourceUrl
          sourceSet
        }
        type
        publishedAt
        modifiedAt
        authors {
          displayName
          preferredUsername
        }
        categories {
          name
          slug
        }
      }
    }
    publishedPosts(limit: $limit, skip: $skip) {
      postId
      title
      slug
      type
      description
      publishedAt
      modifiedAt
      image {
        sourceUrl
        sourceSet
      }
      authors {
        displayName
        preferredUsername
      }
      categories {
        name
        slug
      }
    }
  }
`;
